
export default {
  inject: ['load'],
  data() {
    return {
    };
  },
  methods: {
    getAllUserGridSettingsFunction: function (gridName) {
      //   BottomList800,
      //   TopList800,
      //   MainList115,
      //   MainListDoctor,
      //   MainListAdmission

      if (!this.load.val) {
        this.load.val = true;
      }
      return this.$store.dispatch('getAllUserGridSettings', { gridName }).then(() => {
        if (this.$store.state.userGridSettingsModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          return this.$store.state.userGridSettingsModule.userGridSetting
          // let temp = this.$store.state.userGridSettingsModule.userGridSetting;

          // if (temp) {
          //   try {
          //     this.currentHeaders = JSON.parse(temp);
          //   } catch (e) {
          //     this.currentHeaders = [...this.bottomListTableHeader];
          //   }
          // } else {
          //   this.currentHeaders = [...this.bottomListTableHeader];
          // }


        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userGridSettingsModule.errorStatus) {
            return this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                return this.getAllUserGridSettingsFunction(gridName);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userGridSettingsModule.error400) {
            return this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                return this.getAllUserGridSettingsFunction(gridName);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    setUserGridSettingFunction: function (data) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addUserGridSettings', data).then(() => {
        if (this.$store.state.userGridSettingsModule.successFlag) {
          this.snackText = ' تنظیمات با موفقیت ثبت شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }

        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.userGridSettingsModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.setUserGridSettingFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.userGridSettingsModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.setUserGridSettingFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.userGridSettingsModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
